import { Injectable } from '@angular/core';
import { last, map, ReplaySubject, scan, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UrlService {
  private _urlSubject = new ReplaySubject<string | null>(2);
  public previousUrl$ = this._urlSubject.pipe(
    scan((acc: Array<string>, currentUrl) => {
      acc.push(currentUrl || '');
      return acc.slice(-2);
    }, []),
    take(2),
    last(),
    map(([prev, curr]) => (curr ? prev : null)),
  );

  public updateCurrentUrl(url: string): void {
    this._urlSubject.next(url);
  }
}
